<template>
  <div class="page">
    <div class="banner">
      <div class="text">
        <p class="Title">Hi! look at me!</p>
        <span class="word word1">快速</span>
        <span class="word word2">高效</span>
        <span class="word word3">勤奋</span>
        <span class="word word4">成长</span>
      </div>
    </div>
    <div class="between">
      <p>使用软件：PS、AI、CDR、Vsode、HbuilderX</p>
      <p>熟练掌握：HTML5/CSS3、JavaScript（ES6+）及 Vue3 生态（Composition API、Pinia、Vue Router）</p>
    </div>
    <div class="content">
      <div class="left-content">
        <div style="display: grid;grid-template-columns: 4fr 6fr;">
          <div class="vatar">
            <img style="height: 100%;" src="../assets/vater.jpg" alt="头像">
          </div>
          <div class="information-left">
            <p><span >姓名：</span><span>罗茜蒙</span></p>
            <p><span>专业：</span><span>电子商务技术</span></p>
            <p><span>毕业院校：</span><span>江苏联院</span></p>
          </div>
        </div>
        <div>
          <div style="line-height: 2rem;margin-top: 1rem;border-bottom: 1px solid black;">
            个人经验：两年平面设计经验，一年电商网店经验，一年武术教练经验，在校期间带领团队进行一系列线上商业活动任务。
          </div>
          <div style="line-height: 2rem;margin-top: 1rem;">
            总结：在平面设计，前端开发，项目策划、运营，剪辑，人员管理方面以及各项线上电子商务活动，有一定经验和能力。
          </div>
        </div>
      </div>
      <div class=right-content>
        <p style="z-index: 9999; margin-bottom: auto;font-size: 2rem;font-weight: 500;">点击</p>
        <img class="rotate" :class="{rotating:isRotating}" @click="handleRotate" src="../assets/banner5.jpg" alt="round1">
        <img class="pslogo" :class="{pslogoDown:isDown}" @click="handleDown" src="../assets/pslogo.png" alt="pslogo">
        <img class="girl" :class="{girlUp:isUp}" @click="handleUp"  src="../assets/girl.png" alt="girl">
        <img class="girl1" src="../assets/girl1.png" alt="girl1">
      </div>
    </div>
    <AppFooter style="z-index: 0;"/>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import AppFooter from '@/components/AppFooter.vue';
const isRotating = ref(false)
const isDown = ref(false)
const isUp = ref(false)
const handleRotate = () => {
  isRotating.value = true;
  setTimeout(() => {
    isRotating.value =false
  }, 500);
}
const handleDown = () => {
  isDown.value = true;
  setTimeout(() => {
    isDown.value =false
  }, 500);
}
const handleUp = () => {
  isUp.value = true;
  setTimeout(() => {
    isUp.value =false
  }, 2000);
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page {
  color: var(--main-text, black);
  display: flex;
  flex-direction: column;
}

.banner {
  position: relative;
  height: 70vh;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.5s ease;
}

.banner::before {
  content: '';
  position: absolute;
  background-image: url(../assets/banner1.jpg);
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  animation: blur 1s ease forwards;
  animation-delay: 0.3s;
}

@keyframes blur {
  0% { filter: blur(0px); }
  100% { filter: blur(5px); }
}

.text {
  transform: translateY(2rem);
  color: white;
  font-size: 2rem;
  font-weight: 100;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  padding: 0 20px;
  position: relative; /* 确保文字在背景上方 */
  z-index: 1;
}

.Title {
  opacity: 0;
  animation: fadein 4s ease forwards;
  color: white;
  font-size: 5rem;
  font-weight: 200;
  animation-delay: 2s;
  transition: all 0.5s ease;
  margin-bottom: 0.5rem;
}

.word {
  margin: 1rem;
  opacity: 0;
  animation: fadein 4s ease forwards;
  transition: all 0.5s ease;
}

.word1 { animation-delay: 0s; }
.word2 { animation-delay: 0.3s; }
.word3 { animation-delay: 0.6s; }
.word4 { animation-delay: 0.9s; }

@keyframes fadein {
  to { opacity: 1; }
}
.between{
  padding: 1rem;
  background-color: white;
  font-weight: 300;
}
.content{
  display: grid;
  grid-template-columns: 4fr 6fr;
}
.left-content{
  display: grid;
  grid-template-rows: 4fr 6fr;
  margin: 1rem;
  padding: 1rem;
  border-radius: 1rem;
  background-color: #e5e5e5;
  min-width: 25rem;
}
.vatar{
  width: 10rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  overflow: hidden;
}
.information-left{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.information-left p{
  display: flex;
  justify-content: space-between;
  margin-left: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid black;

}
.right-content{
  overflow: hidden;
  position: relative;
  display: flex;
  transform: translate(-50%,-50%);
  top: 50%;
  left: 50%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  height: 30rem;
}
.rotate{
  position: absolute;
  transform: translate(-50%,-50%);
  left: 90%;
  top: 70%;
  width: 6rem;
  transition: all 0.5s ease;
  z-index: 999;
}
.rotate:hover{
  width: 7rem;
}
.rotating{
  animation: rotate 0.5s linear;
}
@keyframes rotate{
  0%{transform: rotate(0deg);
  left: calc(90% - 3rem);
  top: calc(0% - 3rem);
     }
  25%{transform: rotate(900deg);
  left: calc(90% - 3rem);
  top: calc(100% - 3rem);
     }
  50%{transform: rotate(1800deg);
  left: calc(90% - 3rem);
  top: calc(0% - 3rem);
     }
  75%{transform: rotate(2700deg);
  left: calc(90% - 3rem);
  top: calc(100% - 3rem);
     }
  100%{transform: rotate(3600deg);
  left: calc(90% - 3rem);
  top: calc(70% - 3rem);
     }
}

.pslogo{
  position: absolute;
  transform: translate(-50%,-50%);
  left: 15%;
  top: 20%;
  width: 5rem;
  transition: all 0.5s ease;
  animation: toggle 1s ease-in;
  z-index: 998;
}
.pslogoDown{
  animation: down 0.5s ease-in;
}
.pslogo:hover{
  width: 6rem;
}
@keyframes toggle{
  from{opacity: 0;}
  to{opacity: 1;}
}
@keyframes down{
  0%{top: 20%;left: 15%;}
  40%{top: 5%;left: 10%;opacity: 1;}
  100%{top: 100%;left: 5%;opacity: 0;}
}
.girl,.girl1{
  z-index: 100;
  position: absolute;
  width: 100%;
  transform: translate(-50%,-50%);
  left: 50%;
  top: 99.5%;
}
.girl{
  transform: translate(-50%,-90%);
  top: 100%;
  transition: all 0.5s ease;
}
.girl:hover{
  width: 103%;
}
.girlUp{
  animation: up 2s linear;
}
@keyframes up{
  0%{top: 100%;left: 50%;}
  5%{top: 150%;left: 50%;}
  30%{top: 150%;left: 50%;}
  48%{top: 150%;left: -100%;}
  49%{top: 200%;left: -100%;}
  50%{top: 200%;left: 150%;}
  51%{top: 150%;left: 150%;}
  70%{top: 150%;left: 50%;}
  80%{top: 150%;left: 50%;}
  100%{top: 100%;left: 50%;}
}

/* 响应式适配 */
@media (max-width: 70rem) {
  .banner { height: 70vh; }
  .text { font-size: 1.6rem; }
  .Title { font-size: 4rem; }
}

@media (max-width: 40rem) {
  .banner { height: 50vh; }
  .text {
    transform: translateY(2rem);
    font-size: 1.2rem;
  }
  .Title { font-size: 3rem; 
  }
  .content{grid-template-columns: 1fr;}
  .left-content{
  min-width: auto;
  }
  .vatar{
    width: 8rem;
  }
  }
</style>